export enum Role {
	Flinker = 'Flinker',
	FlinkCompanyMaster = 'FlinkCompanyMaster',
	FlinkCompanyLimited = 'FlinkCompanyLimited',
	FlinkCompanyContributor = 'FlinkCompanyContributor',
	FlinkAdmin = 'FlinkAdmin',
	FlinkAdminMaster = 'FlinkAdminMaster',
}
